import { render, staticRenderFns } from "./wholesale-hierarchy.vue?vue&type=template&id=5f6806ee"
import script from "./wholesale-hierarchy.vue?vue&type=script&lang=js"
export * from "./wholesale-hierarchy.vue?vue&type=script&lang=js"
import style0 from "./wholesale-hierarchy.vue?vue&type=style&index=0&id=5f6806ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports